import Vue from "vue";
import VueRouter from "vue-router";
import { pcRouter } from "./pcRoutes";
import { mobileRouter } from './mobileRoutes'
import { Message } from "element-ui";
import store from "@/store";

Vue.use(VueRouter);

// 检测设备类型的函数
// function isMobile() {
//   return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
// }

let routes;
// if (isMobile()) {
//   // 若为手机端，加载手机端路由配置
//   routes = mobileRouter
// } else {
//   // 若为 PC 端，加载 PC 端路由配置
//   routes = pcRouter
// }
 const width = window.innerWidth;
function isMobileOrTablet() {
  const ua = navigator.userAgent;
  return /Mobile|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone/i.test(ua) ||
      (/Macintosh/i.test(ua) && 'ontouchend' in document); // iPadOS 检测
}
if (isMobileOrTablet() || width < 1024) {
  console.log("当前设备是手机或 iPad");
  // 执行移动端适配逻辑
  routes = mobileRouter
} else {
  console.log("当前设备是桌面设备");
  // 执行桌面端逻辑
  routes = pcRouter
}
// function checkDeviceType() {
//   const width = window.innerWidth;
//   if (width <= 768) {
//     return 'mobile';
//   } else if (width <= 1024) {
//     return 'tablet';
//   } else {
//     return 'pc';
//   }
// }

// if (checkDeviceType() === 'mobile') {
//   routes = mobileRouter
// } else if (checkDeviceType() === 'tablet') {
//   routes = mobileRouter
// } else {
//   routes = pcRouter
// }


const router = new VueRouter({
  mode: 'hash',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
});

// 百度统计管理器
// const BaiduAnalyticsManager = {
//   currentLang: null,
//
//   config: {
//     ch: {
//       id: '367c032834413eacea85a1cecfebb51a',
//       scriptId: 'baidu-tongji-ch'
//     },
//     en: {
//       id: 'de1c1dea4467e8ad364fe79452f527a7',
//       scriptId: 'baidu-tongji-en'
//     }
//   },
//
//   // 清除统计代码（保留_hmt变量）
//   clear() {
//     // 只移除当前语言的脚本
//     if (this.currentLang && this.config[this.currentLang]) {
//       const script = document.getElementById(this.config[this.currentLang].scriptId);
//       if (script) script.remove();
//     }
//
//     // 查找并移除动态加载的hm.js脚本
//     const hmScripts = document.querySelectorAll('script[src^="https://hm.baidu.com/hm.js"]');
//     hmScripts.forEach(script => script.remove());
//
//     // 保留_hmt变量但清空数组
//     window._hmt = window._hmt || [];
//   },
//
//   // 初始化统计代码（百度官方推荐方式）
//   init(lang) {
//     if (this.currentLang === lang) return;
//
//     const config = this.config[lang];
//     if (!config) return;
//
//     // 清除旧代码
//     this.clear();
//
//     // 创建统计脚本（使用百度推荐的标准写法）
//     const script = document.createElement('script');
//     script.id = config.scriptId;
//     script.innerHTML = `
//       var _hmt = _hmt || [];
//       !function() {
//         var hm = document.createElement("script");
//         hm.src = "https://hm.baidu.com/hm.js?${config.id}";
//         var s = document.getElementsByTagName("script")[0];
//         s.parentNode.insertBefore(hm, s);
//       }();
//     `;
//
//     // 插入到head最前面确保优先加载
//     document.head.insertBefore(script, document.head.firstChild);
//
//     this.currentLang = lang;
//
//     // 确保_hmt存在
//     window._hmt = window._hmt || [];
//   }
// };

// 确保应用启动时加载正确的统计代码
// router.onReady(() => {
//   const defaultLanguage = localStorage.getItem('language') === '2' ? 'en' : 'ch'
//   BaiduAnalyticsManager.init(defaultLanguage);
// })
// 初始加载（确保在DOMContentLoaded后执行）
// document.addEventListener('DOMContentLoaded', () => {
//   const defaultLanguage = localStorage.getItem('language') === '2' ? 'en' : 'ch';
//   BaiduAnalyticsManager.init(defaultLanguage);
// });

// 添加全局前置守卫
router.beforeEach((to, from, next) => {

  const language = to.meta?.language;

  if (language === 'ch') {
    localStorage.setItem('language', 1);
  } else if (language === 'en') {
    localStorage.setItem('language', 2);
  }
  // 切换统计代码
  // BaiduAnalyticsManager.init(language);
  // 初始化统计代码（添加延迟确保DOM准备就绪）
  // setTimeout(() => BaiduAnalyticsManager.init(language), 50);


  const token = localStorage.getItem('token');
  // 需要登录的页面（包括PC和移动端的中英文版本）
  const publicPages = [
    '/personalCenter',
    '/en/personalCenter',
    '/personalCenter',
    '/en/personalCenter'
  ];

  // if (to.path === '/') {
  //   next('/');
  // } else
  if (!token && publicPages.includes(to.path)) {
    // 根据当前路由判断是PC端还是移动端，中文还是英文
    const isMobileRoute = to.path.includes('mobile');
    const isChinese = !to.path.startsWith('/en');
    console.log(isChinese, 'isChinese');

    // 设置对应的提示信息和登录页面路径
    const message = isChinese ? '请先登录' : 'Please log in first';
    const loginPath = isMobileRoute
      ? (isChinese ? '/login' : '/en/login')
      : (isChinese ? '/login' : '/en/login');

    Message.error(message);
    setTimeout(() => {
      next(loginPath);
    }, 1000);
  } else {
    if (to.path.includes('%23')) {
      const decodedFullPath = decodeURIComponent(to.fullPath);
      return next(decodedFullPath);
    }
    next();
  }
});


export default router;
